export default __webpack_public_path__ + "static/media/swedgo-screenshot-06.7716fb30.png";